// PWA wiring: the manifest link and the service worker.
//
// WHY THIS IS ALL AT RUNTIME rather than in index.html.
//
// Parcel RESOLVES `<link rel="manifest">` and `navigator.serviceWorker
// .register('/sw.js')`, pulling both into the bundle graph. The manifest makes
// it auto-install @parcel/transformer-webmanifest DURING THE BUILD — a network
// fetch, in a repo whose CI has three separate proxy layers and a documented
// history of DNS-flaky builds — and it rewrites asset filenames, which the
// service worker's fixed root scope cannot use.
//
// So the PWA assets are copied verbatim from public/ to the dist root by the
// build script and referenced here at runtime. Nothing about the PWA can break
// a build.
//
// Everything below is best-effort and never awaited: an app that cannot install
// must still be an app that works.

const MANIFEST_URL = '/manifest.webmanifest';
const APPLE_ICON_URL = '/apple-touch-icon.png';
// Assembled rather than written inline: a string literal here is exactly what
// makes Parcel try to bundle the worker. The file is emitted by the build's
// copy step and must stay at the ROOT — a worker's default scope is its own
// directory, so a hashed or nested one could not control the whole app.
const SW_URL = ['', 'sw.js'].join('/');

function addLink(rel, href) {
  if (document.querySelector(`link[rel="${rel}"]`)) return;
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  document.head.appendChild(link);
}

/** Make the app installable. Safe to call more than once. */
export function installManifest() {
  if (typeof document === 'undefined') return;
  addLink('manifest', MANIFEST_URL);
  // iOS ignores the manifest entirely and reads this instead.
  addLink('apple-touch-icon', APPLE_ICON_URL);
}

export function registerServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // HTTPS or localhost only. The ingress serves this app over plain HTTP too
  // (`ssl-redirect: "false"` in both overlays), and registering there throws
  // rather than quietly no-oping.
  const secure = window.isSecureContext
    || ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (!secure) return;

  // After load: registration otherwise competes with the boot query, and the
  // boot query is what puts a dentist in front of their day.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_URL).catch((err) => {
      console.warn('[pwa] service worker registration failed:', err?.message);
    });
  });
}

/** Both halves, for App.jsx to call once after render. */
export function setupPWA() {
  try {
    installManifest();
    registerServiceWorker();
  } catch (err) {
    console.warn('[pwa] setup skipped:', err?.message);
  }
}

export default setupPWA;
